<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 14:03:01
 * @LastEditors: wang.zhiqin wang.zhiqin@trs.com.cn
 * @LastEditTime: 2025-04-24 11:40:16
 * @FilePath: \jsczt\src\views\home.vue
 * @Description: 部门预决算公开 部门列表
-->
<template>
  <div class="container" :style="{ zoom: scale }">
    <div class="content-wrapper">
      <top></top>
      <div class="current">
        当前位置：首页 > {{ cname }}
      </div>
      <div class="content">
        <div class="content_left">
          <leftTree :curnode="currNode" :cname="cname" @curdata="getCurdata"></leftTree>
        </div>
        <div class="content_right">
          <div class="right_tab">
            <div class="year">
              <myYear @change="getYear" :year="year" @dateRange="getDateRange"></myYear>
            </div>
            <div class="place" @click="dqDialog = true">
            <myRegions :value="curplace"></myRegions>
            </div>
            <div class="choose" @click="getList">查询</div>
          </div>
          <div class="choice">
            <span style="margin-left: 20PX;">
              已选择:
              <span style="margin-left: 15PX;">年份:{{ showYear }}</span>
              <span style="margin-left: 15PX;">地区:{{ choicePlace }}</span>
            </span>
          </div>
          <div class="list3" v-if="judge">
            <ul >
              <li>未到公开时间</li>
            </ul>
          </div>
          <div class="list3">
            <ul v-if="bmoptions.length === 0">
              <li></li>
            </ul>
            <ul v-else>
              <li v-for="item in bmoptions" :key="item.channelid" @click="goto(item)">
                <div class="dian"></div>
                <div class="list3_txt">
                  {{ item.chnldesc }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="footer">
        <div class="footercont">
          主办：江苏省财政厅 备案序号：苏ICP备15009401号
          公安备案号：32010602010331 网站标识码：3200000098 江苏省财政厅版权所有
          <div class="jiucuo">
            <span id="_span_jiucuo">
              <img @click="Link('3200000003')" style="border:0;cursor: pointer;" src="../assets/jiucuonew.png">
            </span>
          </div>
          <div class="dzjg">
            <span id="_ideConac">
              <a href="https://bszs.conac.cn/sitename?method=show&amp;id=105DF988641221CBE053012819ACE317" target="_blank">
                <img id="imgConac" vspace="0" hspace="0" border="0" src="../assets/red.png"></a>
              </span>
            </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dqDialog"
      :append-to-body="true"
      class="my_dialog"
      style="background-color: none">
      <choiceDialog v-if="dialogVisible" @curtext="getcurText"  @close="getClose" :opentype="openType"></choiceDialog>
    </el-dialog>
  </div>
</template>

<script>
import myYear from '../components/myYear.vue'
import myRegions from '../components/myRegions.vue'
import top from '../components/top.vue'
import leftTree from '../components/leftTree.vue'
import choiceDialog from '../components/choiceDialog.vue'
import dayjs from 'dayjs'
export default {
  name: 'overview',
  components: {
    myYear,
    myRegions,
    top,
    leftTree,
    choiceDialog
  },
  data () {
    return {
      year: '',
      showYear: '',
      // 当前节点
      currNode: '',
      // 节点名称
      cname: '',
      dqDialog: false,
      dialogVisible: false,
      // 当前行政区
      curplace: '',
      choicePlace: '',
      // 行政区码
      areaCode: '',
      curParentid: '',
      // 部门列表
      bmoptions: [],
      today: '',
      judge: false,
      storageData: {},
      hasRange: false,
      jsClassinfoid: ['28', '31', '18', '19', '20'],
      openType: 'ys',
      scale: 1 // 初始缩放比例
    }
  },
  computed: {
    getWindowSize () {
      return {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  },
  watch: {
    dqDialog: {
      handler (val) {
        this.dialogVisible = val
      },
      deep: true,
      immediate: true
    },
    currNode: {
      handler (val) {
        if (this.storageData.parentid) {
          this.curParentid = this.curParentid === this.storageData.parentid ? this.curParentid : this.storageData.parentid
        }
        this.hasChilds(this.curParentid)
      },
      deep: true,
      immediate: true
    },
    scale: {
      handler (val) {
        window.addEventListener('load', this.handleResize)
      },
      deep: true,
      immediate: true
    },
    '$route.name': {
      handler (val) {
        this.handleResize()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    window.addEventListener('load', this.handleResize)
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    Link (sitecode) {
    // 该站点需要纠错页面的url地址
    var url = "http://yjsgk.jsczt.cn/#/"
    // 跳转至纠错系统填写页面
    window.open('http://121.43.68.40/exposure/jiucuo.html?site_code=' + sitecode + '&url=' + encodeURIComponent(url))
  },
    handleResize () {
      var width = this.getWindowSize.width
      // 假设你设计稿的宽度是 1920PX
      var designWidth = 1920
      var scale = width / designWidth
      this.scale = scale.toFixed(2)
    },
    getClose (data) {
      if (data) {
        this.dqDialog = false
      }
    },
    getDateRange (date) {
      if (date.split(',')[0]) {
        this.hasRange = true
        localStorage.setItem("rangeyear", date);
        // if (date.split(',')[0] < date.split(',')[1]) {
        //   localStorage.setItem('rangeyear', date.split(',')[1])
        // } else {
        //   localStorage.setItem('rangeyear', date.split(',')[0])
        // }
      }
    },
    getCurdata (item) {
      
      this.currNode = item.classinfoid.toString()
      this.cname = item.cname
      // 更新路径数据
      var classinfoid = this.currNode
      if (this.jsClassinfoid.includes(this.currNode)) {
        this.openType = 'js'
      } else {
        this.openType = 'ys'
      }
      delete this.storageData.place
      this.$router.push({ name: 'overViews', query: { classinfoid, ...this.storageData } })
      // this.$http.post('/yjsUbas/yjs/add', {
      //   browserVersion:navigator.appVersion,
      //     browserName: navigator.appName,
      //     browserLanguage:navigator.language,
      //     areaCode:this.$route.query.code,
      //     areaName:this.choicePlace,
      //     // deptCode:item.deptcode,
      //     // deptName:item.deptname,
      //     // unitCode:"",
      //     // unitName:"",
      //     areaYear:this.$route.query.year,
      //     sourceType:6,
      //     fileType:item.classinfoid,
      //     url:window.location.href
      //   }).then(res => {
      //     // if (res.data.code === 200) {
      //       // this.listData = res.data.data
      //     }
      //   )
      this.addData(item.classinfoid)
    },
    getList () {
      this.showYear = this.year
      if (this.curplace === '') {
        this.$message({
          message: '行政区不能为空',
          type: 'error'
        })
      } else {
        this.storageData.year = this.showYear
        localStorage.setItem('key', JSON.stringify(this.storageData))
        this.choicePlace = this.curplace
        // 更新路径数据
        var classinfoid = this.currNode
        delete this.storageData.place
        this.$router.push({ name: 'overViews', query: { classinfoid, ...this.storageData } })
        this.hasChilds(this.curParentid)
      }
      
    },
    // 当前选中年份
    getYear (data) {
      this.year = data
      this.curplace = ''
      this.areaCode = ''
      if (data !== '自定义') {
        localStorage.setItem('year', data)
        localStorage.setItem('rangeyear', '')
      }
    },
    // 当前选中地区
    getcurText (data) {
      this.areaCode = data.code
      this.curParentid = data.chnlid
      this.curplace = data.chnldesc
      // 存入localStorage
      this.storageData.code = this.areaCode
      this.storageData.place = this.curplace
      this.storageData.parentid = data.chnlid
      if (data.close === false) {
        this.dqDialog = false
      }
    },
    // 判断是否存在子集
    async hasChilds (id) {
      this.bmoptions = []
      await this.$http.get('/api/wcmchannel/hasChild', {
        params: {
          parentId: id,
          classInfoId: this.currNode,
          // 查询部门，部门1，单位0
          isgroup: 1
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.hasChild = res.data.data
          if (this.hasChild) {
            this.getbmDwList(id)
          }
        }
      })
    },
    // 获取部门/单位
    async getbmDwList (id) {
      this.bmoptions = []
      await this.$http.get('/api/wcmchannel/bmDwList', {
        params: {
          parentId: id,
          classInfoId: this.currNode,
          // 查询部门，部门1，单位0
          isgroup: 1
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.bmoptions = res.data.data
        }
      })
    },
    goto (item) {
      console.log(item)
      var data = {
        classinfoid: this.currNode,
        year: this.showYear,
        deptcode: item.code,
        code: item.areacode,
        parentid: this.curParentid,
        deptName:item.chnldesc,
        bmid: item.channelid
      }
      localStorage.setItem('bmname', item.chnldesc)
      this.$router.push({ name: 'overViewt', query: { ...data } })
    },
    async getStartTime (datetype, opentype) {
      this.today = dayjs().format('YYYY-MM-DD')
      await this.$http.post('/api/opentime/getStartTime', {
        areaCode: this.areaCode,
        areaYear: this.showYear,
        dateType: datetype, // 类型（1-政府公开日期 2-部门公开日期 3-单位公开日期）
        openType: opentype // 公开类型（js-决算 ys-预算）
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        if (res.data.code === 200) {
          if (res.data.data) {
            if (this.today < res.data.data.startdate) {
              this.judge = true
            } else {
              this.judge = false
            }
          }
        }
      })
    },
    updateLocalStorageData () {
      this.storageData = JSON.parse(localStorage.getItem('key'))
      if (this.storageData) {
        // 左侧展开节点
        if (this.storageData.year && this.storageData.year === '自定义') {
          this.year = localStorage.getItem('rangeyear')
          this.showYear = this.year
        }
        // 左侧名称
        this.cname = localStorage.getItem('topcname') ? localStorage.getItem('topcname') : this.storageData.cname
      }
      this.addData(this.$route.query.classinfoid)
    },
    isIdExists (treeData, code) {
      // 遍历树形数据的每个节点
      for (let i = 0; i < treeData.length; i++) {
        const node = treeData[i]
        if (node.code === code) {
          this.curplace = node.chnldesc
          return true
        }
        if (node.child && node.child.length > 0) {
          const isExists = this.isIdExists(node.child, code)
          if (isExists) {
            return true
          }
        }
      }
      return false
    },
    getcurArea () {
      this.$http.get('/api/wcmchannel/findxzqh', {
        params: {
          year: this.year,
          openType: this.openType
        }
      }).then(res => {
        if (this.$route.query.code === res.data.data.code) {
          this.curplace = res.data.data.chnldesc
        } else {
          this.isIdExists(res.data.data.child, this.$route.query.code)
        }
        this.choicePlace = this.curplace
        var datas = {
          place: this.curplace,
          code: this.areaCode,
          year: this.year,
          parentid: this.$route.query.parentid
        }
        // 存储路径上的值
        localStorage.setItem('key', JSON.stringify(datas))
        this.getbmDwList(this.curParentid)
        this.updateLocalStorageData()
        
      })
    }
  },
  created () {
    this.year = this.$route.query.year
    this.currNode = this.$route.query.classinfoid
    if (this.jsClassinfoid.includes(this.currNode)) {
      this.openType = 'js'
    } else {
      this.openType = 'ys'
    }
    this.areaCode = this.$route.query.code
    this.curParentid = this.$route.query.parentid
    this.showYear = this.year
    this.getcurArea()
  }
}
</script>
<style scoped>
@import url('../assets/overview.css');
.list3 {
  width: 1160PX;
  border: 1PX solid #d2d2d2;
  background-color: #fff;
  padding-top: 22PX;
  padding-bottom: 22PX;
  cursor: pointer;
}
.list3 ul li {
  font-size: 16PX;
  font-weight: 400;
  color: #161616;
  vertical-align: top;
  height: 50PX;
}
.list3 ul li .dian {
  width: 10PX;
  height: 10PX;
  background: #000000;
  opacity: 0.08;
  border-radius: 50%;
  position: absolute;
  top: 6PX;
  left: -20PX;
}
.list3 ul{
  margin-left: 20PX;
}
.list3 ul li {
  width: 30%;
  display: inline-block;
  position: relative;
  margin-left: 22PX;
}
.choice{
  width: 1160PX;
  background: #e6ecf2;
  margin-left: 2PX;
  margin-bottom: 15PX;
  font-size: 18PX;
  line-height: 40PX;
  color: #747475;
}
</style>



// WEBPACK FOOTER //
// src/views/overviews.vue